import React, { Fragment } from "react"

import InsightAreaListItem from "../../../insight-areas/insight-area-list/InsightAreaListItem"
import InsightAreaListItemShadow from "../../../insight-areas/insight-area-list/InsightAreaListItemShadow"
import expandableItem from "../../../common/ExpandableItem"

const ExpandableInsightAreaListItem = expandableItem(
    ({ toggleExpansion, ...topic }) => (
        <InsightAreaListItem
            onClick={() => toggleExpansion}
            toggleExpansion={toggleExpansion}
            {...topic}
        />
    )
)

const ClusterViewItemTopics = ({ topics, concepts, isFetching, isEditing }) => (
    <div className="widget">
        <h3 className="widget-header">
            <span
                className={`icon icon-${concepts ? "concepts" : "insights"}`}
            />
            {concepts ? "Concepts (Machine-detected topics)" : "Topics"}
        </h3>
        {isEditing && (
            <p>
                {concepts ? "Concepts" : "Topics"} are{" "}
                <strong>automatically</strong> assigned based on the clustered
                articles and <strong>cannot</strong> be edited directly.
            </p>
        )}
        <div className="widget-content list-group items-list cluster-related-items-list">
            {isFetching ? (
                [0, 1, 2].map(index => (
                    <InsightAreaListItemShadow key={index} />
                ))
            ) : (
                <Fragment>
                    {(concepts || topics || []).map(topic => (
                        <ExpandableInsightAreaListItem
                            key={topic.id}
                            {...topic}
                        />
                    ))}
                    {(!topics || !topics.length) &&
                        (!concepts || !concepts.length) && (
                            <p>No {concepts ? "concepts" : "topics"}</p>
                        )}
                </Fragment>
            )}
        </div>
    </div>
)

export default ClusterViewItemTopics
